import { useEffect } from "react";
import styled from "styled-components";
import Lottie from "react-lottie";
import { Button } from "reactstrap";

import Card from "../components/web/mocks/card/Card";
import DesignAnimation from "../assets/lottie/designer.json";
import AppRoutes from "../constants/routes";

import styles from "./WelcomePage.module.scss";

const Title = styled.h1`
  color: white;
  text-align: center;
`;

const SubTitle = styled.h3`
  color: white;
  text-align: center;
`;

const StyledCard = styled(Card)`
  background: white;
  width: 500px;
  max-width: 95%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
`;

const StyledButton = styled(Button)`
  display: inline-block;
  font-weight: 600;
  color: #fff;
  background-color: #5e72e4;
  text-align: center;
  vertical-align: middle;
  border: 1px solid #5e72e4;
  padding: 10px;
  line-height: 1.5;
  border-radius: 10px;
  margin-bottom: 10px;
  margin-top: 10px;

  h4 {
    margin-bottom: 0px;
  }
`;

export default function WelcomePage() {
  useEffect(() => {
    document.title = "Welcome to Ancon Theme Designer";
  }, []);

  function handleNavigateToWebThemer() {
    window.location.href = AppRoutes.OrderWebWL;
  }

  function handleNavigateToAppThemer() {
    window.location.href = AppRoutes.OrderApp;
  }

  function handleNavigateToWLAppThemer() {
    window.location.href = AppRoutes.OrderAppWL;
  }

  return (
    <div className={styles.container}>
      <Title>Welcome</Title>
      <SubTitle>
        Use these awesome tools to generate white label themes for <br />
        Order Web and Order App
      </SubTitle>
      <StyledCard>
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData: DesignAnimation,
          }}
          height={250}
          width={250}
        />
        <h3>What are we designing today?</h3>
        <StyledButton onClick={handleNavigateToWLAppThemer}>
          <h4>Order App WL Theme</h4>
        </StyledButton>
        <StyledButton onClick={handleNavigateToWebThemer}>
          <h4>Order Web WL Theme</h4>
        </StyledButton>
        <StyledButton onClick={handleNavigateToAppThemer}>
          <h4>Ancon Order App Theme</h4>
        </StyledButton>
      </StyledCard>
    </div>
  );
}
